import React from 'react'
import { Icon } from '@chakra-ui/react'

const WhiteCircle = ({ ...props }) => {
  return (
    <Icon
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="16" cy="16" r="16" fill="white" />
    </Icon>
  )
}

export default WhiteCircle
